export const PRIVACY_POLICY_URL = 'https://www.hometurfapp.com/privacy_policy.html';
export const TERMS_OF_SERVICE_URL = 'https://www.hometurfapp.com/terms_of_service.html';
export const ACCESSIBILITY_URL = 'https://www.hometurfapp.com/accessibility.html';
